export const GIG_CARDS_LAZY_OFFSET = 8,
    LIST_VIEW_CARDS_LAZY_OFFSET = 3,
    LISTINGS_DESKTOP_SIZE = 48;

export const LOGO_MAKER_BANNER_INDEX = {
    DESKTOP: 16,
    TABLET: 12,
    MOBILE: 5
};
